import Vue from 'vue';
import Vuex, { MutationTree, ActionTree, GetterTree } from 'vuex';

import { FavoritePagesState } from '../models/store-viewmodel';
import { root } from '@/shared/store/index';
import { Config } from '../models/config-viewmodel';
import { Page } from '../models/page-viewmodel';

Vue.use(Vuex);

const state: FavoritePagesState = {
    favoritePages: [],
    loading: true,
    error: '',
    config: {
        language: '',
        overviewUrl: '',
        labels: {},
        editMode: false
    }
}

const mutations: MutationTree<FavoritePagesState> = {
    setConfig(state, config: Config) {
        state.config = config;
    },

    setLoading(state, loading: boolean) {
        state.loading = loading;
    },

    setFavoritePages(state, pages: Page[]) {
        state.favoritePages = pages;
    },

    addFavoritePage(state, page: Page) {
        state.favoritePages.push(page);
    },

    removeFavoritePage(state, page: Page) {
        state.favoritePages.splice(state.favoritePages.indexOf(page), 1);
    },

    setError(state, error: string) {
        state.error = error;
    }
}

const actions: ActionTree<FavoritePagesState, FavoritePagesState> = {
    setConfig(context, config: Config) {
        context.commit('setConfig', config);
    },

    setLoading(context, loading: boolean) {
        context.commit('setLoading', loading);
    },

    setFavoritePages(context, pages: Page[]) {
        context.commit('setFavoritePages', pages);
    },

    addFavoritePage(context, page: Page) {
        context.commit('addFavoritePage', page);
    },

    removeFavoritePage(context, page: Page) {
        context.commit('removeFavoritePage', page);
    },

    setError(context, error: string) {
        context.commit('setError', error);
    }
}

const getters: GetterTree<FavoritePagesState, FavoritePagesState> = {
    getConfig(state) {
        return state.config;
    },

    getFavoritePages(state) {
        return state.favoritePages;
    },

    getError(state) {
        return state.error;
    },

    getLoading(state) {
        return state.loading;
    },

    getFavoritePagesByDate(state) {
        if (!state.favoritePages?.length) {
            return []
        }
        return [...state.favoritePages].sort((a, b) => {
            const dateA = a?.addedDateTime || '';
            const dateB = b?.addedDateTime || '';

            if (dateA > dateB) return -1;
            if (dateA < dateB) return 1;
            return 0;
        });
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        root
    }
})